// Exact icons matching the Figma design
export function CanteenIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="6" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M6 6L14 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M6 10h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export function LibraryIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="5" width="2.5" height="12" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <rect x="7" y="3" width="2.5" height="14" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <rect x="10" y="4" width="2.5" height="13" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <rect x="13" y="6" width="2.5" height="11" stroke="currentColor" strokeWidth="1.5" fill="none" />
    </svg>
  )
}

export function VisitorsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="3" width="10" height="14" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <rect x="8" y="1" width="4" height="3" rx="0.5" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <line x1="7" y1="7" x2="13" y2="7" stroke="currentColor" strokeWidth="1" />
      <line x1="7" y1="9" x2="13" y2="9" stroke="currentColor" strokeWidth="1" />
      <line x1="7" y1="11" x2="11" y2="11" stroke="currentColor" strokeWidth="1" />
      <line x1="7" y1="13" x2="13" y2="13" stroke="currentColor" strokeWidth="1" />
    </svg>
  )
}

export function AlumniIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7" cy="6" r="1.5" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <circle cx="13" cy="6" r="1.5" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M4 16v-2c0-1.5 1-3 3-3s3 1.5 3 3v2" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M10 16v-2c0-1.5 1-3 3-3s3 1.5 3 3v2" stroke="currentColor" strokeWidth="1.5" fill="none" />
    </svg>
  )
}

export function HostelIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 16V8l7-5 7 5v8" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <rect x="8.5" y="12" width="3" height="4" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <line x1="10" y1="14" x2="10" y2="16" stroke="currentColor" strokeWidth="1" />
      <rect x="5" y="10" width="1.5" height="1.5" stroke="currentColor" strokeWidth="1" fill="none" />
      <rect x="13.5" y="10" width="1.5" height="1.5" stroke="currentColor" strokeWidth="1" fill="none" />
    </svg>
  )
}

export function FacilityIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="1.5" fill="currentColor" />
      <circle cx="5" cy="5" r="1" fill="currentColor" />
      <circle cx="15" cy="5" r="1" fill="currentColor" />
      <circle cx="5" cy="15" r="1" fill="currentColor" />
      <circle cx="15" cy="15" r="1" fill="currentColor" />
      <line x1="6" y1="6" x2="8.5" y2="8.5" stroke="currentColor" strokeWidth="1" />
      <line x1="14" y1="6" x2="11.5" y2="8.5" stroke="currentColor" strokeWidth="1" />
      <line x1="6" y1="14" x2="8.5" y2="11.5" stroke="currentColor" strokeWidth="1" />
      <line x1="14" y1="14" x2="11.5" y2="11.5" stroke="currentColor" strokeWidth="1" />
    </svg>
  )
}

// Additional icons that are imported in sidebar
export function AfterSchoolIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="6" r="1.5" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <circle cx="14" cy="8" r="1.2" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M3 16v-2c0-1.5 1-3 3-3s3 1.5 3 3v2" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M11 16v-1.5c0-1.2 1.2-2.5 3-2.5s3 1.3 3 2.5V16" stroke="currentColor" strokeWidth="1.5" fill="none" />
    </svg>
  )
}

export function InfirmaryIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="6" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <line x1="10" y1="7" x2="10" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="7" y1="10" x2="13" y2="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}
